import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Header from "./Layout/Header";
import Main from "./pages/Main";
import UserFilterPage from "./pages/UserFilterPage";
import UserFilterTable from "./Components/UserFilterTable";
import UserLotsPage from "./pages/UserLotsPage";
import ActiveUserPage from "./features/activeusers/pages/ActiveUserPage";
import SendCodeForm from "./pages/SendCodeForm";
import LoginForm from "./pages/LoginForm";
import BanListPage from "./pages/BanListPage";
import SearchCustomersPage from "./pages/SearchCustomersPage";
import ListLogAnalysisPage from "./pages/ListLogAnalysisPage";
import BinActiveUserPage from "./pages/BinActiveUserPage";
import SearchPage from "./features/search/pages/SearchPage";
import { TestRequest } from "./Components/TestRequest";
import SatuAnalyzer from "./features/activeusers/components/SatuAnalyzer";
import { KtruSourcesPage } from "./pages/KtruSourcesPage";
import KtruSourceAddPage from "./pages/KtruSourceAddPage";
import KtruSourceEditPage from "./pages/KtruSourceEditPage";
import { BackFillData } from "./pages/BackFilData";
import { BackFillDataMongo } from "./pages/BackFillDataMongo";
import LotStatusPage from "./features/lotstatus/pages/LotStatusPage";
import SegmentationTable from "./features/activeusers/components/SegmentationTable";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Navigate to="/send-code" />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/home" element={<Main />} />
        <Route path="/user-filter" element={<UserFilterPage />} />
        <Route path="/filters/:userId" element={<UserFilterTable />} />
        <Route path="/lots" element={<UserLotsPage />} />
        <Route path="/active-users" element={<ActiveUserPage />} />
        <Route path="/send-code" element={<SendCodeForm />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/ban-list" element={<BanListPage />} />
        <Route path="/search-customers" element={<SearchCustomersPage />} />
        <Route path="/List-Log" element={<ListLogAnalysisPage />} />
        <Route
          path="/active-users/:bin/:analysisId"
          element={<BinActiveUserPage />}
        />
        <Route path="/test-request" element={<TestRequest />} />
        <Route path="/satu-analyzer" element={<SatuAnalyzer />} />
        <Route path="/ktru-sources" element={<KtruSourcesPage />} />
        <Route path="/ktru-sources/add" element={<KtruSourceAddPage />} />
        <Route path="/ktru-sources/edit/:id" element={<KtruSourceEditPage />} />
        <Route path="/backfill" element={<BackFillData />} />
        {/* <Route path="/backfill-mongo" element={<BackFillDataMongo />} /> */}
        <Route path="/lot-status" element={<LotStatusPage />} />
        <Route path="/segmentation-table" element={<ActiveUserPage />} />
      </Routes>
    </Router>
  );
}

export default App;
